
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scrcpy",
      function () {
        return require("private-next-pages/scrcpy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scrcpy"])
      });
    }
  